import { DataLayerLibrary, Logger, PluginManager } from '@amzn/aws-d2c-client-plugins';
import { D2CAnalyticsConfigExternal } from '@amzn/aws-d2c-client-plugins/dist/interfaces';
import CustomConfig from '../configuration/customConfig';
import { log, logErr } from './logger';
import * as dataLayer from '../core/dataLayer';

let pluginManager: PluginManager;

/**
 * Looks for the config set in the window.AWSMA.eventTrackerConfig
 * @returns {D2CAnalyticsConfigExternal | undefined}
 */
const getConfigFromGlobalScript = (): D2CAnalyticsConfigExternal | undefined => {
  return CustomConfig.get().eventTrackerConfig;
};

/**
 * Gets the config required for the event tracking plugins.
 * @returns {D2CAnalyticsConfigExternal}
 */
const getConfig = (): D2CAnalyticsConfigExternal => {
  return getConfigFromGlobalScript() || {};
};

/**
 * @returns {Logger}
 */
const getLogger = (): Logger => {
  return {
    log,
    error: logErr,
  };
};

/**
 * @returns {DataLayerLibrary.DataLayer}
 */
const getDataLayer = (): DataLayerLibrary.DataLayer => {
  return dataLayer;
};

/**
 * Gets the instance of the PluginManager
 * @returns {PluginManager}
 */
const getPluginManager = () => {
  if (!pluginManager) {
    pluginManager = new PluginManager(getConfig(), getLogger(), getDataLayer());
  }

  return pluginManager;
};

export default getPluginManager;
